import { render, staticRenderFns } from "./BaseTagCircle.vue?vue&type=template&id=65490a55&scoped=true"
import script from "./BaseTagCircle.vue?vue&type=script&lang=js"
export * from "./BaseTagCircle.vue?vue&type=script&lang=js"
import style0 from "./BaseTagCircle.vue?vue&type=style&index=0&id=65490a55&prod&lang=stylus&scoped=true"
import style1 from "./BaseTagCircle.vue?vue&type=style&index=1&id=65490a55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65490a55",
  null
  
)

export default component.exports